import produce from "immer";
import { handleActions } from "redux-actions";

import type { BankAccount } from "src/interfaces/bank-account.interface";
import { LOG_OUT } from "../system/actions";
import {
  FS_CREATE_ITEMS,
  FS_UPDATE_ITEMS,
  FS_DELETE_ITEMS,
  RESET,
  BANK_ACCOUNT,
} from "../common";

export type BankAccountState = {
  items: BankAccount[];
};

const initialState: BankAccountState = {
  items: [],
};

export const bankAccountReducer = handleActions<BankAccountState, any>(
  {
    [BANK_ACCOUNT + RESET]: (state) => initialState,
    [BANK_ACCOUNT + FS_CREATE_ITEMS]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.items.unshift(...payload);
      }),
    [BANK_ACCOUNT + FS_UPDATE_ITEMS]: (state, { payload }) =>
      produce(state, (draft) => {
        for (const account of payload) {
          const index = draft.items.findIndex((i) => i.id === account.id);
          if (-1 < index) {
            draft.items[index] = account;
          }
        }
      }),
    [BANK_ACCOUNT + FS_DELETE_ITEMS]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.items = state.items.filter(
          (item) => !payload.find((deleted) => deleted.id === item.id)
        );
      }),
    [LOG_OUT]: () => initialState,
  },
  initialState
);
